

























import Vue from 'vue'
import bus from '../model/bus'

export default Vue.extend({
    name: 'ResourceList',
    data() {
        return {
            bus,
            manager: bus.game.EngramManager,
        }
    },
    created() {
        this.manager.map = ''
        this.manager.tag = 'harvestable'
        this.manager.text = ''
    },
    computed: {},
    methods: {},
})
